module.exports = __webpack_public_path__ + "static/media/mail.ae658411.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/UnifiedMessaging/mail.svg
// module id = 1849
// module chunks = 0